import type { Resource } from '../../';
export const product_details_addToExchange: Resource = {"default":"Add To Exchange"};
